import { render, staticRenderFns } from "./FeaturedMatches.vue?vue&type=template&id=0055e873&scoped=true&"
import script from "./FeaturedMatches.vue?vue&type=script&lang=js&"
export * from "./FeaturedMatches.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedMatches.vue?vue&type=style&index=0&id=0055e873&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0055e873",
  null
  
)

component.options.__file = "FeaturedMatches.vue"
export default component.exports